import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    CircularProgress
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { isAuthenticated } from "../auth";
import { create } from "./apiPost";
import { Redirect } from "react-router-dom";

class NewPost extends Component { 

    state = {
            groupId: this.props.match.params.groupId,
            title: "",
            body: "",
            photo: "",
            error: "",
            user: {},
            fileSize: 0,
            loading: false,
            redirectToProfile: false
        };
 
    componentDidMount() {
        this.postData = new FormData();
        this.setState({ user: isAuthenticated().user });
    }

    isValid = () => {        
        const { title, body, fileSize } = this.state;
        if (fileSize > 100000) {
            this.setState({
                error: "File size should be less than 100kb",
                loading: false
            });
            return false;
        }
        if (title.length === 0 || body.length === 0) {
            this.setState({ error: "All fields are required", loading: false });
            return false;
        }
        return true;
    };

    handleChange = name => event => {
        this.setState({ error: "" });
        const value =
            name === "photo" ? event.target.files[0] : event.target.value;

        const fileSize = name === "photo" ? event.target.files[0].size : 0;
        this.postData.set(name, value);
        this.setState({ [name]: value, fileSize });
    };

    clickSubmit = event => {
        event.preventDefault();
        this.setState({ loading: true });

        if (this.isValid()) {
            const userId = isAuthenticated().userId;
            const token = isAuthenticated().token;
            this.postData.set('groupId', this.state.groupId)

            create(userId, token, this.postData).then(data => {
                if (data.error) this.setState({ error: data.error });
                else {
                    this.setState({
                        loading: false,
                        title: "",
                        body: "",
                        redirectToProfile: true
                    });
                }
            });
        }
    };

    newPostForm = (title, body) => (
        <Box component="form" sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
                <input
                    onChange={this.handleChange("photo")}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="photo-upload"
                />
                <label htmlFor="photo-upload">
                    <Button
                        variant="outlined"
                        component="span"
                        startIcon={<UploadFileIcon />}
                        fullWidth
                    >
                        {this.state.photo ? this.state.photo.name : 'Choose Post Photo'}
                    </Button>
                </label>
            </Box>

            <TextField
                fullWidth
                label="Title"
                onChange={this.handleChange("title")}
                type="text"
                value={title}
                margin="normal"
                variant="outlined"
            />

            <TextField
                fullWidth
                label="Body"
                onChange={this.handleChange("body")}
                multiline
                rows={6}
                value={body}
                margin="normal"
                variant="outlined"
            />

            <Button
                onClick={this.clickSubmit}
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
            >
                Create Post
            </Button>
        </Box>
    );

    render() {
        const {
            title,
            body,
            user,
            error,
            loading,
            redirectToProfile
        } = this.state;

        if (redirectToProfile) {
            return <Redirect to={`/user/${user._id}`} />;
        }

        return (
            <Container>
                <Typography variant="h4" sx={{ mt: 5, mb: 5 }}>
                    Create a new post
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                        <Box sx={{ textAlign: 'center' }}>
                            <CircularProgress sx={{ mb: 2 }} />
                            <Typography variant="h6">Loading...</Typography>
                        </Box>
                    </Box>
                )}

                {!loading && this.newPostForm(title, body)}
            </Container>
        );
    }
}

export default NewPost;